import { createAction } from '@ngrx/store';

export const onScrolledToPoint = createAction('[App] Scrolled to load data point');

export const InfinityScrollActions = {
  onScrolledToPoint,
};
